import { Component, OnInit } from '@angular/core';
import { TitleService } from 'libs/portal/src/services/title/title.service';

@Component({
  selector: 'app-location-settings',
  templateUrl: './location-settings.component.html',
  styleUrls: ['./location-settings.component.scss'],
})
export class LocationSettingsComponent implements OnInit {
  constructor(private titleService: TitleService) {}
  ngOnInit() {
    this.titleService.pageTitle = 'Bulk Location Settings';
  }
}
